//eslint-disable-next-line
const specialChars = /[`0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

export default { specialChars };
